import React, { useEffect } from "react";
import styles from "./characteristicCustomForm.module.scss";
import { TextField, SelectBox } from "../../primary";
import constants from "../../../constants/constants.json";

export function CharacteristicCustomFormSingleSelect({
  data,
  index,
  optionData,
  getForm,
  register,
  errors,
  setValue,
  clearErrors,
  singleSelectVal,
  showViewForm,
  onAnswerChange,
}) {
  const viewForm = getForm?.formdata?.find((v) => v.id === data.id);
  const selectedValue = viewForm?.options?.[0] || "";
  const showOther = viewForm?.options?.includes("other");

  useEffect(() => {
    if (showOther) {
      register(`${data.id}-other`, {
        required: data?.isMandatory === 1 ? constants.customForm.responseIsRequired : false,
      });

      if (viewForm?.value !== undefined) {
        setValue(`${data.id}-other`, viewForm?.value, {
          shouldValidate: true,
          shouldDirty: true,
        });
      }
    }
  }, [viewForm?.value, data.id, setValue, register, data?.isMandatory, showOther]);

  const singleSelectValue = (val, index, id) => {
    const fieldName = String(id);
    const normalizedVal = val?.trim?.() || "";
  
    setValue(fieldName, normalizedVal, {
      shouldDirty: true,
      shouldTouch: true,
      shouldValidate: !!normalizedVal,
    });
  
    if (!normalizedVal) {
      clearErrors(fieldName);
    }
  
    singleSelectVal((prev) => {
      const formdata = prev?.formdata || [];
      const idx = formdata.findIndex((f) => f.id === id);
  
      const updatedItem = {
        id,
        options: normalizedVal ? [normalizedVal] : [],
        value: "",
      };
  
      if (idx !== -1) {
        const updated = [...formdata];
        updated[idx] = updatedItem;
        return { ...prev, formdata: updated };
      }
  
      return { ...prev, formdata: [...formdata, updatedItem] };
    });
  };

  const getOtherValue = (e, index) => {
    setValue(`${data.id}-other`, e.target.value, {
      shouldValidate: true,
      shouldDirty: true,
    });
    clearErrors(`${data.id}-other`);

    const value = e.target.value;

    singleSelectVal((prev) => {
      const formdata = prev?.formdata || [];

      if (showViewForm?.formdata?.length > 0 && index > -1) {
        const updated = [...formdata];
        updated[index] = { ...updated[index], value };
        return { ...prev, formdata: updated };
      }

      const idx = formdata.findIndex((f) => f.id === data?.id);
      if (idx !== -1) {
        const updated = [...formdata];
        updated[idx] = { ...updated[idx], value };
        return { ...prev, formdata: updated };
      }

      return prev;
    });
  };

  return (
    <div>
      <SelectBox
        id={String(data.id)}
        name={String(data.id)}
        label={data.desc}
        classes={{
          column: `col-12 ${styles.col_spec}`,
          inputClassName: `${styles.basic_select} singleSelect`,
          labelClassName: `col-6 col-form-label ${styles.label_spec}`,
          inputColumn: `col-5 p-0 ${styles.select_wrapper}`,
        }}
        optionValue={optionData}
        validator={register({ required: data?.isMandatory === 1 ? constants.customForm.responseIsRequired : false })}
        errors={errors}
        placeholder="Select"
        defaultValue={selectedValue}
        onChange={(e) => {
          singleSelectValue(e.target.value, index, data.id);
          onAnswerChange();
        }}
        required={data?.isMandatory === 1}
        labelSubText={<p className={styles.coreDesc} >{data?.coreDesc}</p>}
      />

      {showOther && (
        <TextField
          id={`${data.id}-other`}
          name={`${data.id}-other`}
          classes={{
            column: `col-12 ${styles.col_spec}`,
            inputColumn: `offset-6 col-5 p-0 d-flex flex-column`,
            inputClassName: `${styles.basic_input} getOtherval`,
          }}
          type="text"
          validator={register(`${data.id}-other`, {
            required: data?.isMandatory === 1 ? constants.customForm.responseIsRequired : false,
          })}
          errors={errors}
          defaultValue={viewForm?.value || ""}
          onChange={(e) => getOtherValue(e, index)}
          required={data?.isMandatory === 1}
        />
      )}
    </div>
  );
}
